//  Basically
//{
//  summaries: {
//    'eventId': summaries,
//  },
//  results: {
//    'trainingId': results
//  }
//}

export default {
  summaries: eventId => ['summaries', String(eventId)],
  results: trainingId => ['results', String(trainingId)],
  context: key => ['context', key],
}
